import { create } from "zustand";
import type { PlacePreviewFeature } from "./api";

interface MapSelectionState {
  /** Currently selected place feature (type can be null for preview mode) */
  selected: PlacePreviewFeature | null;

  /** Select a place */
  select: (place: PlacePreviewFeature) => void;

  /** Clear selection */
  deselect: () => void;
}

export const useMapSelection = create<MapSelectionState>((set) => ({
  selected: null,

  select: (place) => {
    set({ selected: place });
  },

  deselect: () => {
    set({ selected: null });
  },
}));
